export const paymentConditions = [
    "À Réception",
    "À 10 jours",
    "À 15 jours",
    "Fin de mois",
    "30 jours date de facture",
    "30 jours fdm",
    "À 45 jours",
    "60 jours fdm",
  ];

export const tvaOptions = [
    "TVA 20%",
    "TVA 10%",
    "TVA 5.5%",
    "TVA 0% UE",
    "TVA 0% HORS UE",
  ];
export const acquisitionOptions = ["Téléprospection", "Visite clientèle", "Réseaux sociaux", "Prise de reférence", "Contrat cadre", "Autre"];
export const clientConditionOptions = {facturation:paymentConditions,tvaRate:tvaOptions,clientAcquisition:acquisitionOptions};
